import React, { useState, useEffect } from 'react';

import { Button, Checkbox, Form, Input, Alert } from 'antd';

const Ball = ({ ball, visible }) => {

    const [visb, setVisible] = useState(visible);

    useEffect(() => {
        //console.log(visible)
        setVisible(visible)
      }, [visible]);

    return (
        <>
            {visb && ball == 1 && <img src="../img/billiards/1.png" width="28" height="28" />}
            {visb && ball == 2 && <img src="../img/billiards/2.png" width="28" height="28" />}
            {visb && ball == 3 && <img src="../img/billiards/3.png" width="28" height="28" />}
            {visb && ball == 4 && <img src="../img/billiards/4.png" width="28" height="28" />}
            {visb && ball == 5 && <img src="../img/billiards/5.png" width="28" height="28" />}
            {visb && ball == 6 && <img src="../img/billiards/6.png" width="28" height="28" />}
            {visb && ball == 7 && <img src="../img/billiards/7.png" width="28" height="28" />}
            {visb && ball == 8 && <img src="../img/billiards/8.png" width="28" height="28" />}
            {visb && ball == 9 && <img src="../img/billiards/9.png" width="28" height="28" />}
            {visb && ball == 10 && <img src="../img/billiards/10.png" width="28" height="28" />}
            {visb && ball == 11 && <img src="../img/billiards/11.png" width="28" height="28" />}
            {visb && ball == 12 && <img src="../img/billiards/12.png" width="28" height="28" />}
            {visb && ball == 13 && <img src="../img/billiards/13.png" width="28" height="28" />}
            {visb && ball == 14 && <img src="../img/billiards/14.png" width="28" height="28" />}
            {visb && ball == 15 && <img src="../img/billiards/15.png" width="28" height="28" />}
        </>
    );
};

export default Ball;